<div>
  <div matSnackBarLabel class="bold flex items-center">
    <mat-icon aria-hidden="true" color="warn" svgIcon="DECLINA"></mat-icon>
    <span style="margin-left: 1rem;">ERRORE!</span>
  </div>

  <div class="flex justify-between">
    <div matSnackBarLabel>
      {{data.message}}
    </div>
    <span matSnackBarActions>
      <button mat-button color="warn" (click)="snackBarRef.dismissWithAction()">{{data.action}}</button>
    </span>
  </div>



</div>